/**
 * 搜索栏
 */

import React, { useState } from "react";
import { useStore } from "../store";

export default function SearchBar() {
  const { searchQuery, setSearchQuery } = useStore();
  const [value, setValue] = useState(searchQuery);

  const handleSearch = () => {
    setSearchQuery(value);
  };

  const handleClear = () => {
    setValue("");
    setSearchQuery("");
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder="搜索站点名称、域名..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button className="btn btn-primary" onClick={handleSearch}>
        搜索
      </button>
      {searchQuery && (
        <button className="btn btn-ghost" onClick={handleClear}>
          清除
        </button>
      )}
    </div>
  );
}